 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		69: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		69: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-mobile","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","8":"buybox~promotion-products-lazy~quick-view","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"ratings-and-reviews-mobile","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"buybox~quick-view","16":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","17":"media-gallery-overlay~media-gallery-overlay-mobile","18":"promotion-products-lazy~quick-view","19":"ratings-and-reviews-desktop","21":"StoreLayout","22":"add-to-list-drawer","23":"aisle-bay","24":"augmented-reality","25":"bath-renovation","26":"breadcrumbs","27":"browse-and-search","28":"browse-and-search-mobile","29":"buybox","30":"calculator-pipcalculator","31":"collections","32":"collections-mobile","33":"compare","34":"consumer-card-messaging","35":"customer-image-overlay","36":"drawer","37":"emt-generated-content","38":"emt-links","39":"fbr","40":"global-custom-configurator","41":"hammerjs","43":"home","44":"magic-apron","45":"measurement-guide","46":"measurement-guide-overlay-content","47":"media-gallery-filmstrip-mobile","48":"media-gallery-overlay","49":"media-gallery-overlay-mobile","50":"message-types","51":"orange-lens","52":"order-sample","53":"order-sample-drawer","54":"overlay","55":"paint-reorder","56":"paint-reorder-mobile","57":"pep","58":"pep-mobile","59":"product","60":"product-mobile","61":"product-overview","62":"promotion-products-lazy","63":"question","64":"questions-and-answers","65":"quick-view","66":"ratings-and-reviews","67":"results","68":"returns-messaging","70":"share-to-email-overlay","71":"share-to-pinterest-overlay","72":"size-guide-overlay","73":"specifications","74":"stylequiz","75":"super-sku","76":"vendor-collection-products","77":"vendor-collections","78":"vendor-collections-mobile","80":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"eab3076ca17bb92d6ca2","1":"1e7a91ae5465878678c0","2":"aed31282d0f5f44fc868","3":"66ffc0584eedcd893d63","4":"8728a2803fcea70cd6ac","5":"02d74d885e007a8f8c3a","6":"0a421d31b63a75f552a8","7":"5cec933e7027c17def06","8":"2b3f7f9a30addd8761c6","9":"f8519c762e77b4a2edc8","10":"a79b6b5f2d2a984f08d6","11":"ffaf45403477a79a76bd","12":"c8eb4892c55dfd810e7b","13":"9b64495bca00f6790fb2","14":"0c5c4b87b1f10e5745a1","15":"850f0b398bbb06581ac4","16":"43e0605f0c1a26774828","17":"3bc1915e72e8e8e47c1c","18":"00a082f7d3b457d5d9c4","19":"af865343ed4b66311dc1","20":"94361e94e2b16b272157","21":"34a6fe18e8d066443b91","22":"40ab88ff7c94f2dcda3b","23":"6f13f9704c327d007c06","24":"fc57bfa0ace5829bcdb4","25":"cb0533e7dccffb4a86b6","26":"61e5c488c65201ad818f","27":"458c6ad8108a510b2062","28":"0ee0b093a5cbbd33be72","29":"9c7d4855672539952c6f","30":"dda169c28984ba337139","31":"43a7c4a58360733fadf6","32":"8c777451b03dab8297a1","33":"5bc6691863ad35730a22","34":"9f6561cbdf8c466bb609","35":"f50c79a6445428e62edc","36":"aad00b7e0b42f2ce7029","37":"7da82b05c53f9450a31e","38":"ab5880b66ef12407057c","39":"73c7007c67ef0496cda7","40":"b066522e6371f2264081","41":"b88117458ec0ad7bc957","43":"be242762005e2e8254a0","44":"a49f9b7062eaa5a32654","45":"d09467e98bc1982f1023","46":"0c876596de4f922d6f30","47":"bf7f3884cb1e921623a1","48":"62ae2daa05fa6e11417c","49":"4f85bfa2e387e213967c","50":"f23865282ac301a48588","51":"2948d2fd03e14ce2a3d5","52":"f9ef398f4bbc73487a7b","53":"8af6aebbd715737b5192","54":"b5e5020edfcdb679dbf2","55":"d2928310b56d26900b83","56":"d9a6c3b3bc30ef95f9a8","57":"59e440d06af5031d60ec","58":"7d0d7d7c96ae89ab5dc8","59":"14b863776159b161d440","60":"d47cac81e1189af51319","61":"943c83b69b74a93b0fa9","62":"875591788424f9741d80","63":"863b1ff25737e70a2b19","64":"f6bf5ae0c9092f1edb67","65":"41c68b285d2644d320d9","66":"edf331fbdb977b9812c6","67":"ae6ce3bbb6a1923b2332","68":"c34d7b2e5d404e885657","70":"e054f478f3bd61b389e9","71":"462696c7c5670cbdac1f","72":"b781badc5ec69362ae91","73":"385217596c3ddcc15bd4","74":"cd5a05717413e8286111","75":"b3f5635068c5cd394144","76":"bb112deb61f368987f3e","77":"9651fabe98cc52ca5eba","78":"b4d9feecbe33f884cda2","80":"fb32313a22f6fcf5f2fa","81":"fee77ca85f01f11f931e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"15":1,"17":1,"18":1,"23":1,"27":1,"28":1,"29":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"40":1,"44":1,"47":1,"48":1,"49":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"64":1,"65":1,"66":1,"72":1,"74":1,"75":1,"76":1,"77":1,"78":1,"80":1,"81":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-mobile","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","8":"buybox~promotion-products-lazy~quick-view","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"ratings-and-reviews-mobile","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"buybox~quick-view","16":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","17":"media-gallery-overlay~media-gallery-overlay-mobile","18":"promotion-products-lazy~quick-view","19":"ratings-and-reviews-desktop","21":"StoreLayout","22":"add-to-list-drawer","23":"aisle-bay","24":"augmented-reality","25":"bath-renovation","26":"breadcrumbs","27":"browse-and-search","28":"browse-and-search-mobile","29":"buybox","30":"calculator-pipcalculator","31":"collections","32":"collections-mobile","33":"compare","34":"consumer-card-messaging","35":"customer-image-overlay","36":"drawer","37":"emt-generated-content","38":"emt-links","39":"fbr","40":"global-custom-configurator","41":"hammerjs","43":"home","44":"magic-apron","45":"measurement-guide","46":"measurement-guide-overlay-content","47":"media-gallery-filmstrip-mobile","48":"media-gallery-overlay","49":"media-gallery-overlay-mobile","50":"message-types","51":"orange-lens","52":"order-sample","53":"order-sample-drawer","54":"overlay","55":"paint-reorder","56":"paint-reorder-mobile","57":"pep","58":"pep-mobile","59":"product","60":"product-mobile","61":"product-overview","62":"promotion-products-lazy","63":"question","64":"questions-and-answers","65":"quick-view","66":"ratings-and-reviews","67":"results","68":"returns-messaging","70":"share-to-email-overlay","71":"share-to-pinterest-overlay","72":"size-guide-overlay","73":"specifications","74":"stylequiz","75":"super-sku","76":"vendor-collection-products","77":"vendor-collections","78":"vendor-collections-mobile","80":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"46d0ac7da3db8adb1367","1":"66bba79b70e3924b990e","2":"31d6cfe0d16ae931b73c","3":"aaa0137a65d448ed5f64","4":"daabb420d3c92e26f8a9","5":"50d430c72ccc3cf96a34","6":"89d9163eeb30e835d559","7":"65f1d7aedc445dc5836f","8":"ed633198e4ae6dea4ede","9":"59d72f4e8c0806257828","10":"f38aaee08af9e508beb8","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"5d24181bd44df8a5e6ea","16":"31d6cfe0d16ae931b73c","17":"7d0187e52ef9b9f0e49f","18":"2a09750166a70e474555","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"d94b956aa532c1a50c65","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"96c3f664169e9b48c9f2","28":"838a3dcb3f28f3765d8d","29":"4dff0eff57ce1f73df40","30":"31d6cfe0d16ae931b73c","31":"695bd54517042a9a77f9","32":"225478d55948dbe63cbd","33":"ffe192ad5912a5ec682f","34":"c07ce9ab259c3f695942","35":"c466036523aec2558c34","36":"fc73174b407ad863c497","37":"b49004ddac99adec2224","38":"31d6cfe0d16ae931b73c","39":"88e24c7aafcf93ae6cc6","40":"1a5562a08d12f7682989","41":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"ceebf150d8a696023a14","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"c185dd507b97bcc2bd63","48":"7013f93350fef54e51c5","49":"75d310264ecdef1a204b","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"a7854c7c69de3b8290ab","55":"fec8a13e093dc667a809","56":"470a801d7c258d3514c0","57":"75a826a75b75e024c50b","58":"53bae0c64bb8bee5edb4","59":"da4090e15f09e471a375","60":"a650329cbb1a493abe3a","61":"be155bb5d11dacdc4bb8","62":"c7e4a3cb02089bb4d052","63":"31d6cfe0d16ae931b73c","64":"d70c859b20e57c1599c5","65":"3fb67ef60d9f4cf19fb8","66":"66f604bea0b8a537b75d","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"453dfc2640779a848cc6","73":"31d6cfe0d16ae931b73c","74":"6c6bdd949ddd0752832b","75":"922dbc8ed510a58afe20","76":"e518e335254638969e62","77":"1530a07f4e3793770a96","78":"776dcc62e56a3978707d","80":"3196bab71cc04636bdaf","81":"ed633198e4ae6dea4ede"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
